import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'

import './style.scss'
import { AuthProvider } from './utils'

// React Query 클라이언트 설정
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 1,
			refetchOnWindowFocus: false,
			staleTime: 1000 * 60 * 5, // 5분
			onError: (error) => {
				// 401/403 에러는 axiosInstance에서 처리하므로 여기서는 로깅만
				if (error.response?.status === 401 || error.response?.status === 403) {
					console.error('인증 에러:', error)
				}
			},
		},
		mutations: {
			onError: (error) => {
				console.error('Mutation 에러:', error)
			},
		},
	},
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<BrowserRouter>
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<App />
			</AuthProvider>
		</QueryClientProvider>
	</BrowserRouter>,
)
